export const Selectors = {
	nextButton: 'next-button',
	prevButton: 'prev-button',
	currentQuestionIndex: 'question-index',
	totalQuestions: 'total-questions',
	directions: 'directions',
	testIntro: 'preview-test-intro',
	questionSlider: 'preview-question-slider',
};
